import React from 'react';
import classNames from 'classnames';
import { List } from 'immutable';

import { Paragraph } from '@uncinc/react-drupal-core';

import {
  Container,
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';

import { WysiwygField, NewsletterBlock } from '../../../components';

import {
  SCREEN_MOBILE,
  SCREEN_NORMAL,
  SCREEN_TABLET,
} from '../../../config/constants';
import './style.scss';

const NodeLandingPage = ({ entity, className }) => {
  const classes = classNames(className, 'NodeLandingPage', {
    NodeLandingPage__no_hero: !entity.getIn(['field_hero_image', 0]),
  });
  return (
    <article typeof="schema:WebPage" className={classes}>
      <Container>
        <div className="NodeLandingPage__hero">
          {entity.getIn(['field_hero_image', 0]) && (
            <Image
              lazyload={false}
              includeWebP
              src={{
                [SCREEN_MOBILE]: entity.getIn(['field_hero_image', 0, 'styles', 'hero_mobile']),
                [SCREEN_TABLET]: entity.getIn(['field_hero_image', 0, 'styles', 'hero_tablet']),
                [SCREEN_NORMAL]: entity.getIn(['field_hero_image', 0, 'styles', 'hero_desktop']),
              }}
              alt={entity.getIn(['field_hero_image', 0, 'alt'], '')}
            />
          )}
        </div>
        <div className="row">
          <div className="col-12 col-md-9">
            <div className="NodeLandingPage__info" id="main">
              <h1 property="schema:name" className="NodeLandingPage__title">
                {entity.getIn(['title', 0, 'value'])}
              </h1>
              <WysiwygField
                property="schema:text"
                className="NodeLandingPage__body subheading2"
                html={entity.getIn(['body', 0, 'processed'], '')}
              />
            </div>
          </div>
          <div className="NodeLandingPage__sidebar col-12 col-md-3">
            {entity.get('field_paragraphs', List()).map((paragraph) => {
              const id = paragraph.get('target_id');
              const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);
              return (
                <div key={`${id}:paragrap h:${language}`}>
                  <a className="icon-after icon-arrow-right" href={`#${id}`}>{paragraph.getIn(['entity', 'field_title', 0, 'value'])}</a>
                </div>
              );
            })}
          </div>
        </div>
      </Container>

      {entity.get('field_paragraphs') ? (
        <div className="NodeLandingPage__paragraphs">
          {entity.get('field_paragraphs', List()).map((paragraph) => {
            const id = paragraph.get('target_id');
            const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);
            return (
              <div key={`paragraph:${id}:${language}`} id={id}>
                <Paragraph
                  id={id}
                  entity={paragraph.get('entity')}
                />
              </div>
            );
          })}
        </div>
      ) : null}

      {/* Newsletter subscription block */}
      <NewsletterBlock />
    </article>
  );
};

export default NodeLandingPage;
